import { User } from '@rtls/core/models/human/user.model';
import { Result } from '@rtls/core/models/result.model';
import { Observable } from 'rxjs';

export abstract class RtlsUserService<T extends User> {
	abstract addRolesToUser(rolesIds: string[], userId: string, client: string): Observable<any>;
	abstract addUser(user: User): Observable<any>;
	abstract delete(userId: string): Observable<boolean>;
	abstract updateUser(userId: string, userData: User): Observable<User>;
	abstract getAllUsers(): Observable<Result<User>>;
	abstract getClients(): Observable<Result<string>>;
	abstract getUserRoles(userId: string, client: string): Observable<any>;
	abstract removeRolesFromUser(rolesIds: string[], userId: string, client: string): Observable<any>;
}
